export default __webpack_public_path__ + "static/media/js.166865da.png";